import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useParams } from "react-router-dom";
import { getAdminEventTypeDetailAction } from "../../../store/actions/adminEventType";
import constant from "../../../util/constant";
import eventTypeConstant from "../../../util/eventTypeConstant";
import { ViewEventType } from "../../shared/eventTypes";

const { API_STATUS } = constant;
const { EVENT_TYPE_API_TYPES } = eventTypeConstant;

const AdminEventTypeDetail = () => {
  const dispatch = useDispatch();
  const { apiType, status, adminEventTypeDetail, message } = useSelector( state => ( {
    apiType: state.adminEventType.apiType,
    status: state.adminEventType.status,
    adminEventTypeDetail: state.adminEventType.adminEventTypeDetail,
    message: state.adminEventType.message,
  } ) );
  const { eventTypeId } = useParams();

  useEffect( () => {
    if( eventTypeId !== "0" ) {
      dispatch( getAdminEventTypeDetailAction( eventTypeId ) );
    }
  }, [ eventTypeId ] );
  useEffect( () => {
    if(
      status === API_STATUS.SUCCESS &&
        apiType === EVENT_TYPE_API_TYPES.ENABLE_DISABLE_EVENT_TYPE_GAME
    ) {
      toastr.success( message.message );
    }
  }, [] );

  return <ViewEventType eventTypeDetail={adminEventTypeDetail} type='admin'/>;
};

export default AdminEventTypeDetail;
